import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ECompareActionTypes {
  ToggleCompare = 'compare/toggleCompare',
}

export type TToggleCompare = ITypedReduxAction<ECompareActionTypes.ToggleCompare, void>;

export const toggleCompare: () => TToggleCompare = actionGenerator<ECompareActionTypes.ToggleCompare>(
  ECompareActionTypes.ToggleCompare,
);

export type TCompareActions = TToggleCompare;
